import documentTemplates, {
  DocumentTemplatesListParams
} from "@/getinfo-api/document-templates";
import mutations from "@/store/modules/mutations";
import api from "@/getinfo-api";

export default {
  namespaced: true,
  state: {
    limit: 30,
    offset: 0,
    list: [],
    count: 0,
    showMoreSpinner: false,
    showFullSpinner: false
  },
  actions: {
    async CLEAR_TEMPLATES(ctx: any) {
      ctx.commit("CLEAR");
    },
    async LIST(ctx: any, params: DocumentTemplatesListParams) {
      let _params: DocumentTemplatesListParams = {
        ...params,
        limit: ctx.state.limit,
        offset: ctx.state.offset
      };
      try {
        let response = await documentTemplates(_params);
        ctx.commit("ADD_TO_LIST", response.data.items);
        ctx.commit("SET_COUNT", response.data.count);
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    async DELETE_TEMPLATE(ctx: any, templateId: string) {
      try {
        await api.DocTemplateApi._delete(templateId);
        ctx.commit("REMOVE_FROM_LIST", templateId);
        ctx.commit("DECREASE_COUNT");
        ctx.commit("DECREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    }
  },
  mutations: {
    ...mutations.mutations
  },
  getters: {
    GET_TEMPLATES(state: any) {
      return state.list;
    },
    GET_COUNT(state: any) {
      return state.count;
    }
  }
};
